import {
  ESSAY_SHRINKTIONARY_WORDS,
  shrinktionaryUrl,
} from "@/data/shrinktionaryLinks";

interface AlsoOnShrinktionaryProps {
  /** Perspectives essay slug used to look up the term list and the UTM campaign. */
  slug: string;
  className?: string;
}

/**
 * "Words in this essay" block that links to the canonical Shrinktionary
 * definition for each core term the essay uses. Renders nothing when the
 * essay has no matching entries so essays like
 * /digital-mental-health-needs-more-than-convenience stay clean.
 */
export function AlsoOnShrinktionary({ slug, className }: AlsoOnShrinktionaryProps) {
  const entries = ESSAY_SHRINKTIONARY_WORDS[slug];
  if (!entries || entries.length === 0) return null;

  const campaign = `auto_perspectives_${slug.replace(/-/g, "_")}_words`;

  return (
    <aside
      role="complementary"
      aria-label="Words in this essay, defined on Shrinktionary"
      className={`also-on-shrinktionary not-prose border-l-2 border-accent/40 pl-5 py-2 ${className ?? ""}`}
    >
      <p className="m-0 text-xs font-bold tracking-[0.2em] uppercase text-accent">
        Words in this essay
      </p>
      <p className="mt-3 mb-0 text-sm md:text-base font-light leading-relaxed text-secondary">
        Defined on Shrinktionary, the language layer of The Shrink Network:{" "}
        {entries.map((entry, i) => (
          <span key={entry.slug}>
            <a
              href={shrinktionaryUrl(entry.slug, campaign)}
              target="_blank"
              rel="noopener noreferrer"
              className="underline decoration-accent/40 underline-offset-4 hover:decoration-accent transition-colors"
            >
              {entry.label}
            </a>
            {i < entries.length - 2
              ? ", "
              : i === entries.length - 2
                ? ", and "
                : "."}
          </span>
        ))}
      </p>
    </aside>
  );
}
